// Full checkout module merged from legacy `assets/js/checkout.js`.
import { debounce } from '../helpers/utils.js';

export function initCheckout() {
    if (typeof window.PlancModules === 'undefined') window.PlancModules = {};
    if (window.PlancModules.checkout) return;
    window.PlancModules.checkout = true;

    try {
        if (typeof window.initCheckout === 'function') {
            window.initCheckout();
            return;
        }

        const $ = window.jQuery || window.$;
        if (typeof $ === 'undefined') return;

        // Build the CheckoutEnhancements object
        const CheckoutEnhancements = {
            init: function() {
                // establish a scoped container for checkout interactions to avoid global delegation
                this.$scope = $('#customer_details').length ? $('#customer_details') : ($('form.checkout').length ? $('form.checkout') : $(document));
                this.initPaymentMethods();
                this.initFormValidation();
                this.initSuccessModal();
                this.initCardFormatting();
                this.initScrollAnimations();
                this.initFormSteps();
            },

            initPaymentMethods: function() {
                const scope = this.$scope || $(document);
                scope.on('change', '.payment-option input[type="radio"]', function() {
                    scope.find('.payment-card').removeClass('border-purple-500 bg-purple-50');
                    $(this).closest('.payment-option').find('.payment-card').addClass('border-purple-500 bg-purple-50');
                });
                scope.find('.payment-option input[type="radio"]:checked').trigger('change');

                scope.on('change', 'input[name="payment_method"]', function() {
                    const selectedMethod = $(this).val();
                    scope.find('.payment_box').hide();
                    scope.find('#payment_method_' + selectedMethod).closest('li').find('.payment_box').show();
                });
            },

            initFormValidation: function() {
                const scope = this.$scope || $(document);
                scope.on('blur', 'input[required], select[required]', function() {
                    if (!$(this).val().trim()) {
                        $(this).addClass('border-red-500').removeClass('border-green-500');
                        this.showValidationMessage && this.showValidationMessage('This field is required');
                    } else {
                        $(this).removeClass('border-red-500').addClass('border-green-500');
                        this.hideValidationMessage && this.hideValidationMessage();
                    }
                });
                scope.on('blur', 'input[type="email"]', function() {
                    const email = $(this).val().trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (email && !emailRegex.test(email)) {
                        $(this).addClass('border-red-500').removeClass('border-green-500');
                        this.showValidationMessage && this.showValidationMessage('Please enter a valid email address');
                    } else if (email) {
                        $(this).removeClass('border-red-500').addClass('border-green-500');
                        this.hideValidationMessage && this.hideValidationMessage();
                    }
                });
                scope.on('blur', 'input[type="tel"]', function() {
                    const phoneRaw = $(this).val().trim();
                    if (!phoneRaw) return;
                    let normalized = phoneRaw;
                    if (normalized.startsWith('+')) {
                        normalized = '+' + normalized.slice(1).replace(/\D/g, '');
                    } else {
                        normalized = normalized.replace(/\D/g, '');
                    }
                    const phoneRegex = /^[+]?([1-9]\d{0,15})$/;
                    if (!phoneRegex.test(normalized)) {
                        $(this).addClass('border-red-500').removeClass('border-green-500');
                        this.showValidationMessage && this.showValidationMessage('Please enter a valid phone number');
                    } else {
                        $(this).removeClass('border-red-500').addClass('border-green-500');
                        this.hideValidationMessage && this.hideValidationMessage();
                    }
                });
                (this.$scope || $(document)).on('submit', 'form.checkout', function(e) {
                    let hasErrors = false;
                    $(this).find('input[required], select[required]').each(function() {
                        if (!$(this).val().trim()) {
                            $(this).addClass('border-red-500');
                            hasErrors = true;
                        }
                    });
                    if (hasErrors) {
                        e.preventDefault();
                        $('html, body').animate({ scrollTop: $('.border-red-500').first().offset().top - 100 }, 300);
                        CheckoutEnhancements.showNotification('Please fill in all required fields', 'error');
                    }
                });
            },

            initSuccessModal: function() {
                const scopeEvt = this.$scope || $(document);
                scopeEvt.on('checkout_place_order_success', function(event, result) {
                    if (result.result === 'success') {
                        $('#success-modal').removeClass('hidden').addClass('show');
                        $('body').addClass('overflow-hidden');
                        if (result.order_id) {
                            $('#success-modal').find('p').html(`Thank you for your purchase. Your order #${result.order_id} has been placed successfully and will be processed within 24 hours.`);
                        }
                    }
                });
                window.closeModal = window.closeModal || function() {
                    $('#success-modal').addClass('hidden').removeClass('show');
                    $('body').removeClass('overflow-hidden');
                };
                (this.$scope || $(document)).on('click', '#success-modal', function(e) { if (e.target === this) window.closeModal(); });
            },

            initCardFormatting: function() {
                const scope = this.$scope || $(document);
                scope.on('input', 'input[name="cardnumber"], #cardnumber', function() {
                    let value = $(this).val().replace(/\s/g, '').replace(/[^0-9]/gi, '');
                    let formattedValue = value.match(/.{1,4}/g)?.join(' ') || value;
                    if (formattedValue !== $(this).val()) $(this).val(formattedValue);
                });
                scope.on('input', 'input[name="expiry"], #expiry', function() {
                    let value = $(this).val().replace(/\D/g, '');
                    if (value.length >= 2) value = value.substring(0,2) + '/' + value.substring(2,4);
                    $(this).val(value);
                });
                scope.on('input', 'input[name="cvv"], #cvv', function() {
                    let value = $(this).val().replace(/\D/g, '').substring(0,4);
                    $(this).val(value);
                });
            },

            initScrollAnimations: function() {
                if (typeof IntersectionObserver === 'undefined') return;
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('slide-in'); });
                }, { threshold: 0.1 });
                $('.checkout-card, .trust-signal').each(function() { observer.observe(this); });
            },

            initFormSteps: function() {
                const scope = this.$scope || $(document);
                scope.on('blur', '.checkout-section:not(:last-child) input[required]:last', function() {
                    if ($(this).val() && !$(this).hasClass('border-red-500')) {
                        const nextSection = $(this).closest('.checkout-section').next('.checkout-section');
                        if (nextSection.length) setTimeout(() => { $('html, body').animate({ scrollTop: nextSection.offset().top - 100 }, 500); }, 300);
                    }
                });
                this.updateProgressSteps();
            },

            updateProgressSteps: function() {
                const update = () => {
                    const personalFields = $('#customer_details input[required]');
                    const personalComplete = personalFields.length > 0 && personalFields.filter(function() { return $(this).val().trim() !== ''; }).length === personalFields.length;
                    if (personalComplete) {
                        $('.step-indicator').eq(0).find('.w-8').removeClass('bg-gray-300').addClass('bg-purple-600');
                        $('.step-indicator').eq(0).find('span').removeClass('text-gray-500').addClass('text-purple-600');
                    }
                };

                // Prefer a MutationObserver to avoid polling; fallback to a 2s interval if not available
                const target = document.querySelector('#customer_details');
                if (target && window.MutationObserver) {
                    const obs = new MutationObserver(debounce(update, 300));
                    obs.observe(target, { childList: true, subtree: true, characterData: true });
                    // run once initially
                    update();
                } else {
                    update();
                    setInterval(update, 2000);
                }
            },

            showNotification: function(message, type = 'info') {
                try { if (window.PlancNotify && typeof window.PlancNotify.show === 'function') { window.PlancNotify.show(message, type); return; } } catch (e) { if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('PlancNotify.show failed', e); }
                const notification = $(
                    `<div class="notification fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${type === 'error' ? 'bg-red-500' : 'bg-blue-500'} text-white">${message}</div>`
                );
                $('body').append(notification);
                setTimeout(() => { notification.fadeOut(() => notification.remove()); }, 5000);
            }
        };

        // Helpers for validation messages on Elements (keep original behavior)
        Element.prototype.showValidationMessage = Element.prototype.showValidationMessage || function(message) {
            this.hideValidationMessage && this.hideValidationMessage();
            const errorDiv = document.createElement('div');
            errorDiv.className = 'validation-error text-red-500 text-sm mt-1';
            errorDiv.textContent = message;
            this.parentNode.appendChild(errorDiv);
        };
        Element.prototype.hideValidationMessage = Element.prototype.hideValidationMessage || function() {
            const errorDiv = this.parentNode.querySelector('.validation-error');
            if (errorDiv) errorDiv.remove();
        };

        $(document).ready(function() {
            CheckoutEnhancements.init();

            // Cache stable nodes used by checkout UI (place order button and success modal)
            const $scope = $('#customer_details').length ? $('#customer_details') : ($('form.checkout').length ? $('form.checkout') : $(document));

            // Integrations from legacy file
            $('body').on('checkout_error', function() {
                $('.woocommerce-error').each(function() {
                    const errorText = $(this).text();
                    CheckoutEnhancements.showNotification(errorText, 'error');
                });
            });

            $('body').on('checkout_place_order_success', function(event, data) {
                if (data.result === 'success') {
                    $('.checkout-card').addClass('animate-pulse');
                    const $modal = window.__planc_cached && window.__planc_cached.$successModal && window.__planc_cached.$successModal.length ? window.__planc_cached.$successModal : $('#success-modal');
                    setTimeout(() => { $modal.removeClass('hidden').addClass('show'); }, 1000);
                }
            });

            const $place = window.__planc_cached && window.__planc_cached.$placeOrder && window.__planc_cached.$placeOrder.length ? window.__planc_cached.$placeOrder : $scope.find('#place_order');
            ($place.length ? $place : $scope).on('click', '#place_order', function() {
                $(this).addClass('loading').prop('disabled', true);
                $(this).html('<i class="fas fa-spinner fa-spin mr-2"></i>Processing Order...');
                setTimeout(() => { $(this).removeClass('loading').prop('disabled', false); $(this).html('🔒 Place Secure Order →'); }, 10000);
            });
        });

        // Card detection helper (exposed globally as it was before)
        const detectCardType = function(number) {
            const patterns = { visa: /^4/, mastercard: /^5[1-5]/, amex: /^3[47]/, discover: /^6(?:011|5)/ };
            for (const [type, pattern] of Object.entries(patterns)) { if (pattern.test(number)) return type; }
            return 'unknown';
        };

        // Throttle/dedupe card icon detection to avoid running on every keystroke
        const handleCardIcon = debounce(function(ev) {
            const $el = $(ev.target);
            const cardType = detectCardType($el.val().replace(/\s/g, ''));
            const cardIcon = $el.siblings('.card-icon');
            if (cardIcon.length) {
                cardIcon.removeClass('fa-cc-visa fa-cc-mastercard fa-cc-amex fa-cc-discover');
                if (cardType !== 'unknown') cardIcon.addClass(`fa-cc-${cardType}`);
            }
        }, 150);

        $(document).on('input', 'input[name="cardnumber"], #cardnumber', handleCardIcon);

    } catch (e) {
        if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('initCheckout failed', e);
    }
}
